import { Icon } from '@shopify/polaris';
import { LockIcon } from '@shopify/polaris-icons';
import styled from 'styled-components';

interface TabBadgeProps {
  children: string;
  tone?: 'info' | 'success' | 'warning' | 'critical' | 'attention';
  locked?: boolean;
}

const StyledBadge = styled.span<{ $tone: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${(props) => {
    switch (props.$tone) {
      case 'success':
        return '#d4f4dd';
      case 'warning':
        return '#fff4e5';
      case 'critical':
        return '#ffd6d6';
      case 'attention':
        return '#fff7d6';
      case 'info':
      default:
        return '#e3f2fd';
    }
  }};
  color: ${(props) => {
    switch (props.$tone) {
      case 'success':
        return '#1a7f37';
      case 'warning':
        return '#916a00';
      case 'critical':
        return '#c5000f';
      case 'attention':
        return '#7a5c00';
      case 'info':
      default:
        return '#0b5fc0';
    }
  }};
`;

const LockIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  width: 14px;
  height: 14px;

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const TabBadge: React.FC<TabBadgeProps> = ({ children, tone = 'info', locked = false }) => {
  if (locked) {
    return (
      <StyledBadge $tone={tone}>
        <LockIconWrapper>
          <Icon source={LockIcon} tone="info" />
        </LockIconWrapper>
        {children}
      </StyledBadge>
    );
  }

  return <StyledBadge $tone={tone}>{children}</StyledBadge>;
};
